import Cookies from "js-cookie";
import { BASE_URL } from "./connectionUrl";
import { showToast } from "../utils/toastUtil";
import dayjs from "dayjs";
const authStaging = Cookies.get("authStaging")
  ? JSON.parse(Cookies.get("authStaging"))
  : null;
const token = authStaging?.token || "";

export const getAvailableSlots = async (date) => {
  const url = `${BASE_URL}/api/v1/appointments/available_slots?date=${date}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Fetching available slots failed:", error);
    throw error;
  }
};

export const getSearchPatient = async ({ q, perPage, page }) => {
  const url = `${BASE_URL}/api/v1/patients?q=${q}&page=${page}&per_page=${perPage}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getPatient = async (id) => {
  const url = `${BASE_URL}/api/v1/patients/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getEducationOptions = async (type) => {
  const url = `${BASE_URL}/api/v1/master/${type}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}}`,
      },
    });

    const data = await res.json();

    return data?.payload;
  } catch (error) {
    return error;
  }
};

export const getClinicalData = async (patientId, appointmentId, names) => {
  const params = names.map((n) => `name[]=${n}`).join("&");
  const url = `${BASE_URL}/api/v1/clinical_data?${params}&patient_id=${patientId}&appointment_id=${appointmentId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Token ${token}` },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const getStaticDataList = async (type) => {
  const url = `${BASE_URL}/api/v1/clinical_data/static_data_list?type=${type}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Token ${token}` },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const getDoctorList = async () => {
  const url = `${BASE_URL}/api/v1/doctors`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    // console.log("API Response:", data);
    return data.payload;
  } catch (error) {
    console.error("Error fetching doctor list:", error);
    throw error;
  }
};

export const getDoctorPlans = async (id, visitType = null) => {
  let type = visitType ? visitType.toLowerCase() : null;

  const url = `${BASE_URL}/api/v1/billings/specialist_plans?doctor_id=${id}&visit_type=${type}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    // console.log("API Response:", data);
    return data;
  } catch (error) {
    console.error("Error fetching doctor list:", error);
    throw error;
  }
};

export const getInvestigationAccordingToDr = async (id, visitType = null) => {
  const url = `${BASE_URL}/api/v1/specialists/${id}/default_investigations`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    // console.log("API Response:", data);
    return data;
  } catch (error) {
    console.error("Error fetching doctor list:", error);
    throw error;
  }
};

export const getAppointmentCount = async () => {
  const url = `${BASE_URL}/api/v1/appointments/daily_appointments_stats`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    // console.log("API Response:", data);
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getFutureAppointment = async (date, page, per_page) => {
  const url = `${BASE_URL}/api/v1/appointments/date_wise_appointments_status?date=${date}&page=${page}&per_page=${per_page}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getupcomingHolidays = async () => {
  const url = `${BASE_URL}/api/v1/appointments/upcoming_holiday_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getFilterDoctorAppointment = async ({
  visitDate,
  status,
  // visitIteq,
  doctorId,
}) => {
  const url = `${BASE_URL}/api/v1/appointments/filter_visits?q[visit_date_eq]=${visitDate}&q[status_eq]=${status}&doctor_id=${doctorId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getCallReminderDetails = async (id) => {
  const url = `${BASE_URL}/api/v1/appointments/call_details?appointment_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const appointmentDetailByPatient = async (
  patient_id,
  sort_column,
  sort_order,
  page,
  per_page,
) => {
  const url = `${BASE_URL}/api/v1/appointments?patient_id=${patient_id}&sort_column=${sort_column}&sort_order=${sort_order}&page=${page}&per_page=${per_page}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
///// get apis for prescription page///////////

export const appointmentDetail = async (id) => {
  const url = `${BASE_URL}/api/v1/appointments/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getPatientPrescription = async (id) => {
  const url = `${BASE_URL}/api/v1/prescriptions/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicineList = async (q) => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicines_list?q=${q}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getDescriptionList = async (q) => {
  const url = `${BASE_URL}/api/v1/medicines/descriptions?q=${q}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getReferDoctor = async () => {
  const url = `${BASE_URL}/api/v1/referrers?type=all`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const TreatmentList = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/treatments`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllTreatmentShortCodeList = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/special_instructions_shortcodes`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const selectedTreatment = async (id) => {
  const url = `${BASE_URL}/api/v1/treatments/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const doctorAppointmentStats = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/doctor_appointment_stats`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const medicalTestShortCode = async (id) => {
  const url = `${BASE_URL}/api/v1/medical_tests?shortcode=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const followUpList = async (query) => {
  const url = `${BASE_URL}/api/v1/medicines/followup?q=${query}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload.followups;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const videosList = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/videos`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMailTemplate = async (referrerId, patientId) => {
  const url = `${BASE_URL}/api/v1/prescriptions/referrer_template?referrer_id=${referrerId}&patient_id=${patientId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getSplInst = async (chip) => {
  const url = `${BASE_URL}/api/v1/prescriptions/special_instructions?code=${chip}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalReports = async (id) => {
  const url = `${BASE_URL}/api/v1/prescriptions/medical_reports?patient_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicineRemarkList = async (q) => {
  const url = `${BASE_URL}/api/v1/medicines/remarks?q=${q}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

// export const getInvestigationListTrue = async (q) => {
//   const url = `${BASE_URL}/api/v1/prescriptions/investigations?is_investigation=true`;
//   try {
//     const res = await fetch(url, {
//       method: "GET",
//       headers: {
//         Authorization: `Token ${token}`,
//       },
//     });

//     if (!res.ok) {
//       throw new Error(`HTTP error! status: ${res.status}`);
//     }

//     const data = await res.json();
//     // console.log(data);
//     return data;
//   } catch (error) {
//     console.error("Error fetching :", error);
//     return error;
//   }
// };

export const getInvestigationList = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/default_investigations`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    // console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllMedicine = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicines_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllMedicalTestCategory = async () => {
  const url = `${BASE_URL}/api/v1/medical_tests/medical_test_category_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllLabList = async () => {
  const url = `${BASE_URL}/api/v1/medical_tests/lab_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllMedicalTestAndCompositeLab = async (page, perPage, q) => {
  const url = q
    ? `${BASE_URL}/api/v1/medical_tests?q=${q}`
    : `${BASE_URL}/api/v1/medical_tests?page=${page}&?perPage=${perPage}`;
  // const url = `${BASE_URL}/api/v1/medical_tests?type=all`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllMedicineSalt = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicine_salts_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllMedicineSaltPharmacy = async () => {
  // /api/v1/pharmacy/medicine_salts
  const url = `${BASE_URL}/api/v1/pharmacy/medicine_salts?type=all`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicineSaltPharmacySearch = async (q, page, itemPerPage) => {
  const url = q
    ? `${BASE_URL}/api/v1/pharmacy/medicine_salts?q=${encodeURIComponent(q)}&page=${page || 1}&per_page=${itemPerPage || 10}`
    : `${BASE_URL}/api/v1/pharmacy/medicine_salts?page=${page || 1}&per_page=${itemPerPage || 10}`;

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching medicine salt pharmacy search:", error);
    return error;
  }
};

export const getAllMedicineDescription = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicine_descriptions`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAllRemarks = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicines_remarks
`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getRecomendations = async () => {
  const url = `${BASE_URL}/api/v1/prescriptions/recomendations`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalTestShortCodeList = async () => {
  const url = `${BASE_URL}/api/v1/medical_tests/medical_test_shortcodes`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalTestsList = async () => {
  const url = `${BASE_URL}/api/v1/medical_tests/medical_tests_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

// api for billing //////

export const getBillingInvoices = async (date, type) => {
  // const url = `${BASE_URL}/api/v1/invoices`;

  const url = new URL(`${BASE_URL}/api/v1/invoices`);

  // ✅ Add query parameters conditionally
  if (date) {
    url.searchParams.append("start_date", date);
  }

  if (type && type !== "All") {
    url.searchParams.append("department_id", type);
  }

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalTestList = async () => {
  const url = `${BASE_URL}/api/v1/billings/departments_medical_tests_list`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalTestById = async (id) => {
  const url = `${BASE_URL}/api/v1/medical_tests/${id}`;
  //  const url = `${BASE_URL}/api/v1/medical_tests/daycare_procedure?id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getProcedureMedicalTestById = async (id, type) => {
  // const url = `${BASE_URL}/api/v1/medical_tests/${id}`;
  if (!id) {
    showToast("id is not define for the selected test", "ERROR");
    return;
  }
  const url = `${BASE_URL}/api/v1/medical_tests/daycare_procedure?id=${id}&type=${type}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getInvoiceDataById = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const rePrintInvoice = async (id) => {
  const url = `${BASE_URL}/api/v1/invoices/${id}/reprint`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getAppointmentCountDetail = async (
  page = 1,
  per_page = 10,
  type = null,
) => {
  // const endpoint =
  //   type === null
  //     ? `/api/v1/pharmacy/medicines?page=${page}&per_page=${per_page}`
  //     : `/api/v1/pharmacy/medicines?type=${type}`;

  const endpoint =
    type === "all"
      ? `/api/v1/prescriptions/show_appointment_list?page=${page}&per_page=${per_page}`
      : `/api/v1/prescriptions/show_appointment_list?type=${type}&page=${1}&per_page=${per_page}`;
  try {
    const res = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          Authorization: `Token ${token}`,
        },
      },
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getQuickCheckPatient = async (id) => {
  const url = `${BASE_URL}/api/v1/quick_check?doctor_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getCollectionData = async (
  start_date,
  end_date,
  paymentType,
  departmentType,
) => {
  const fallBack = dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD");

  let url = `${BASE_URL}/api/v1/billings/daily_collections?start_date=${
    start_date || fallBack
  }&end_date=${end_date || fallBack}`;

  if (paymentType) {
    url += `&payment_type=${paymentType}`;
  }

  if (departmentType) {
    url += `&department=${departmentType}`;
  }

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getMedicalTestByPatientId = async (id) => {
  const url = `${BASE_URL}/api/v1/appointments/${id}/medical_tests`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

// api for lab
export const getCountOfTests = async () => {
  const url = `${BASE_URL}/api/v1/labs`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data?.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getPatientPreviousReport = async (id, mobile, date) => {
  const endpoint = date
    ? `/api/v1/labs/previous_reports?patient_id=${id}&mobile=${mobile}&date=${date}`
    : `/api/v1/labs/previous_reports?patient_id=${id}`;
  const url = `${BASE_URL}${endpoint}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data?.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getPendingLabReport = async (page, per_page) => {
  const url = `${BASE_URL}/api/v1/labs/pending_tests?page=${page}&per_page=${per_page}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getLabPatientsReportData = async (testDate) => {
  // console.log(testDate, "testDate");
  const endpoint = testDate
    ? `/api/v1/labs/patients?date=${testDate}`
    : `/api/v1/labs/patients`;
  const url = `${BASE_URL}${endpoint}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data?.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const getShowTestList = async ({ id, date = "" }) => {
  const endpoint = `/api/v1/labs/show_tests_list?patient_id=${id}${
    date ? `&date=${date}` : ""
  }`;

  const url = `${BASE_URL}${endpoint}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    return data?.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};
export const postMarkStatus = async (payload) => {
  const { status, medical_test_id, invoice_item_id, patient_id } = payload;
  const url = `${BASE_URL}/api/v1/labs/mark_status?status=${status}&medical_test_id=${medical_test_id}&invoice_item_id=${invoice_item_id}&patient_id=${patient_id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    return error;
  }
};

export const sendReferrerMail = async (data, referrerId, patientId) => {
  const strippedData = encodeURIComponent(data.content); // Encode the data to be used in the URL
  const url = `${BASE_URL}/api/v1/prescriptions/send_referrer_mail?referrer_id=${referrerId}&patient_id=${patientId}&content=${strippedData}`;
  try {
    const res = await fetch(url, {
      method: "GET", // Keep as GET
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    const result = await res.json();
    return result;
  } catch (error) {
    return error;
  }
};

//for pharmacy

export const getTotalCollection = async (
  startDate,
  status,
  endDate,
  page,
  itemPerPage,
  q,
) => {
  // Build query params dynamically
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (page) params.append("page", page);
  if (itemPerPage) params.append("per_page", itemPerPage);
  if (status) params.append("status", status);
  if (q) params.append("q", q);

  const url = `${BASE_URL}/api/v1/pharmacy/daily_collections?${params?.toString()}`;

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicineByName = async (
  medicineNames,
  currentName,
  appointmentId = null,
  age,
  weight,
) => {
  let queryParams = `names=${medicineNames}&current_name=${currentName}`;

  // If appointmentId exists → send it
  if (appointmentId) {
    queryParams += `&appointment_id=${appointmentId}`;
  }

  // if age is below 18
  const showBabyPotionCalculation = age < 18 ? true : false;
  if (age && weight && age < 18) {
    queryParams += `&show_baby_potion_calculation=${showBabyPotionCalculation}`;
    queryParams += `&age=${age}`;
    queryParams += `&weight=${weight}`;
  }

  const url = `${BASE_URL}/api/v1/medicines/medicine_by_name?${queryParams}`;

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicineDetail = async (id) => {
  const url = `${BASE_URL}/api/v1/medicines/detail?id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getPriceByQuantity = async (
  medicineId,
  quantity,
  batchId = null,
  prescription_id,
  signal,
  is_return = false,
) => {
  const url = `${BASE_URL}/api/v1/medicines/get_price_by_quantity?id=${medicineId}&quantity=${quantity}&batch_id=${batchId}${prescription_id ? `&prescription_id=${prescription_id}` : ""}${is_return ? `&is_return=true` : ""}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
      signal,
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      // Surface the backend message (e.g. batch out of stock) to the caller.
      // Flag it explicitly so callers can detect the failure regardless of body shape.
      return {
        ...(data || {}),
        __httpError: true,
        __httpStatus: res.status,
      };
    }
    return data;
  } catch (error) {
    if (error.name === "AbortError") throw error;
    console.error("Error fetching :", error);
    return error;
  }
};

export const getPriceByQuantityForReturn = async (medicineId, quantity) => {
  const url = `${BASE_URL}/api/v1/medicines/get_price_by_quantity?id=${medicineId}&quantity=${quantity}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getPharmacyDetails = async () => {
  const url = `${BASE_URL}/api/v1/pharmacy/details`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { Authorization: `Token ${token}` },
    });
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return await res.json();
  } catch (error) {
    console.error("Error fetching pharmacy details:", error);
    return error;
  }
};

export const pharmacyIndex = async () => {
  const url = `${BASE_URL}/api/v1/pharmacy`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getInvoice = async (id) => {
  const url = `${BASE_URL}/api/v1/pharmacy/edit_invoice?invoice_id=${id}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const refundInvoice = async (invoiceId) => {
  const url = `${BASE_URL}/api/v1/pharmacy/refund?invoice_id=${invoiceId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const reprintInvoice = async (invoiceId, prescriptionId) => {
  const url = `${BASE_URL}/api/v1/pharmacy/reprint?invoice_id=${invoiceId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const prePatientMedicine = async (prescriptionId) => {
  const url = `${BASE_URL}/api/v1/pharmacy/patient_medicines?prescription_id=${prescriptionId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    const data = await res.json();
    return data.payload;
  } catch (error) {
    console.error("Error fetching :", error);
    return error;
  }
};

export const getMedicalTestListLab = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  const endpoint = !type
    ? `/api/v1/medical_tests?page=${page}&perPage=${pageSize}`
    : `/api/v1/medical_tests?q=${type}`;
  // : `/api/v1/medical_tests?page=${page}&perPage=${pageSize}&q=${type}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicalTestDetail = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/medical_tests/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

//  purchase order pharmacy admin api
export const getPurchaseOrderList = async (
  page = 1,
  pageSize = 10,
  type = null,
  startDate,
  endDate,
) => {
  let queryParams = [`page=${page}`, `per_page=${pageSize}`];

  if (type) {
    // queryParams.push(`q=`);
    queryParams.push(`supplier_id=${type}`);
    if (startDate && startDate !== null) {
      queryParams.push(`purchase_start_date=${startDate}`);
    }
    if (endDate && endDate !== null) {
      queryParams.push(`purchase_end_date=${endDate}`);
    }
  }

  const endpoint = `/api/v1/pharmacy/purchase_orders?${queryParams.join("&")}`;

  // const endpoint =
  //   !type
  //     ? `/api/v1/pharmacy/purchase_orders?page=${page}&perPage=${pageSize}`
  //     : `/api/v1/pharmacy/purchase_orders?page=${page}&per_page=${pageSize}&q=_type=cash&supplier_id=${type}&purchase_start_date=${startDate}&purchase_end_date=${endDate}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

// Item-level purchases view: which medicines were purchased in a date range.
// Primary: single call to /purchase_orders/purchase_items (backend-aggregated).
// Fallback (until that endpoint is deployed): assemble the same shape from the
// purchase-order list + details for the range.
export const getPurchaseItemsList = async (
  page = 1,
  pageSize = 10,
  q = null,
  startDate,
  endDate,
) => {
  const params = [`page=${page}`, `per_page=${pageSize}`];
  if (q) params.push(`q=${encodeURIComponent(q)}`);
  if (startDate) params.push(`start_date=${startDate}`);
  if (endDate) params.push(`end_date=${endDate}`);

  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/pharmacy/purchase_orders/purchase_items?${params.join("&")}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    if (response.ok) {
      const data = await response.json();
      if (data?.status?.status === "SUCCESS") return data;
    }
    throw new Error(`purchase_items -> HTTP ${response.status}`);
  } catch (e) {
    console.warn(
      "[purchaseItems] single-call endpoint unavailable, assembling from purchase orders:",
      e.message,
    );
    return assemblePurchaseItemsFallback(page, pageSize, q, startDate, endDate);
  }
};

const assemblePurchaseItemsFallback = async (
  page,
  pageSize,
  q,
  startDate,
  endDate,
) => {
  const today = new Date().toISOString().slice(0, 10);
  const start = startDate || today;
  const end = endDate || start;

  const poRes = await fetch(
    `${BASE_URL}/api/v1/pharmacy/purchase_orders?page=1&per_page=100&purchase_start_date=${start}&purchase_end_date=${end}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    },
  );
  const poData = await poRes.json();
  const orders = (poData?.payload?.purchase_orders || []).filter(
    (o) =>
      o.purchase_date && o.purchase_date >= start && o.purchase_date <= end,
  );

  const details = new Array(orders.length);
  let next = 0;
  const worker = async () => {
    while (next < orders.length) {
      const i = next++;
      try {
        const d = await getPurchaseOrderDetail(orders[i].id);
        details[i] = d?.payload?.purchase_order || d?.payload || {};
      } catch {
        details[i] = {};
      }
    }
  };
  await Promise.all(Array.from({ length: 5 }, worker));

  let items = [];
  orders.forEach((o, i) => {
    (details[i]?.purchase_items || []).forEach((it) =>
      items.push({
        ...it,
        purchase_date: o.purchase_date,
        bill_number: o.bill_number,
        supplier_name: o.supplier?.name,
      }),
    );
  });

  if (q) {
    const needle = q.toLowerCase();
    items = items.filter(
      (it) =>
        (it.medicine_name || "").toLowerCase().includes(needle) ||
        (it.lab_inventory_name || "").toLowerCase().includes(needle) ||
        (it.batch || "").toLowerCase().includes(needle),
    );
  }

  const totals = {
    total_items: items.length,
    total_quantity: items.reduce((s, it) => s + (it.quantity || 0), 0),
    total_free_quantity: items.reduce((s, it) => s + (it.free_quantity || 0), 0),
    total_amount:
      Math.round(items.reduce((s, it) => s + (Number(it.amount) || 0), 0) * 100) /
      100,
  };

  const startIdx = (page - 1) * pageSize;
  return {
    payload: { purchase_items: items.slice(startIdx, startIdx + pageSize) },
    meta: {
      page: String(page),
      per_page: String(pageSize),
      total_count: items.length,
      totals,
      start_date: start,
      end_date: end,
      fallback: true,
    },
    status: { status: "SUCCESS" },
  };
};

export const getSupplierList = async (page = 1, pageSize = 10, type = null) => {
  const endpoint = !type
    ? `/api/v1/pharmacy/suppliers?page=${page}&perPage=${pageSize}`
    : `/api/v1/pharmacy/suppliers?q=${type}&page=${1}&per_page=${pageSize || 10}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getPurchaseOrderDetail = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/purchase_orders/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getSupplierDetails = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/suppliers/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineDetails = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicines/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineSaltDetails = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicine_salts/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getLabInventories = async () => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/lab_inventories?type=all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getPackList = async () => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/purchase_orders/medicines_packing`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getQuickCheckReports = async (patientId, appointmentId) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/medical_test_reports/current_reports?patient_id=${patientId}&appointment_id=${appointmentId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getFormTypeList = async () => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicines/medicine_form_types`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching purchase_orders list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineListAdmin = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  const endpoint = !type
    ? `/api/v1/pharmacy/medicines?page=${page}&per_page=${pageSize}`
    : `/api/v1/pharmacy/medicines?q=${type}&page=${page || 1}&per_page=${pageSize || 10}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineSaltListAdmin = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  const endpoint = !type
    ? `/api/v1/pharmacy/medicine_salts?page=${page}&per_page=${pageSize}`
    : `/api/v1/pharmacy/medicine_salts?q=${type}&page=${page || 1}&per_page=${pageSize || 10}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineBatch = async (id) => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/pharmacy/medicine_batches/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getPatientReminderRecords = async (patientId, prescriptionId) => {
  const url = `${BASE_URL}/api/v1/prescriptions/medicine_reminders_stats?patient_id=${patientId}&prescription_id=${prescriptionId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getPatientQuery = async (patientId) => {
  const url = `${BASE_URL}/api/v1/queries?prescription_id=${patientId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Token ${token}}`,
      },
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getIPDCharges = async () => {
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/ipd/billings/admission_charges`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching charges  list ipd");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const admissionListSearchIPD = async (q) => {
  try {
    const endpoint = q
      ? `/api/v1/ipd/admissions?status=ready_discharge&type=billing&q=${q}`
      : `/api/v1/ipd/admissions?status=ready_discharge&type=billing`;
    const response = await fetch(
      // eslint-disable-next-line no-undef

      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching charges  list ipd");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const orgDetails = async () => {
  const authCookie = Cookies.get("authStaging") ? JSON.parse(Cookies.get("authStaging")) : null;
  const freshToken = authCookie?.token || token;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}/api/v1/organizations/details`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${freshToken}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching org details  list ipd");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const labTestUndo = async (
  reportId,
  medicalTestId,
  invoiceItemId,
  patientId,
) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/labs/undo_test_report?report_id=${reportId}&medical_test_id=${medicalTestId}&invoice_item_id=${invoiceItemId}&patient_id=${patientId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineEnquiryList = async (
  id,
  page = 1,
  pageSize = 10,
  startDate,
  endDate,
) => {
  if (!id) {
    return;
  }
  const endpoint = `/api/v1/admin/reports/medicines_enquiry?id=${id}&start_date=${startDate}&end_date=${endDate}&per_page=${pageSize}&page=${page}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const showQuery = async (id) => {
  if (!id) {
    return;
  }
  const endpoint = `/api/v1/queries/${id}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching query");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

// Supported server-side filters on /admin/treatments
const TREATMENT_FILTER_KEYS = [
  "q",
  "name",
  "diagnosis",
  "medical_tests",
  "special_instructions",
  "start_date",
  "end_date",
];

// `filters` accepts either a plain search string (legacy callers pass the
// debounced search term) or an object of the keys above.
export const treatmentTemplateList = async (
  page = 1,
  pageSize = 10,
  filters = null,
) => {
  const f =
    filters && typeof filters === "object" ? filters : filters ? { q: filters } : {};

  const params = new URLSearchParams();
  params.append("page", page || 1);
  params.append("per_page", pageSize || 10);
  TREATMENT_FILTER_KEYS.forEach((key) => {
    const value = f[key];
    if (value != null && String(value).trim() !== "")
      params.append(key, String(value).trim());
  });

  const endpoint = `/api/v1/admin/treatments?${params.toString()}`;

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getDosageList = async (
  page = 1,
  pageSize = 10,
  q,
  type = null,
) => {
  let endpoint;
  if (type === "all") {
    // NO pagination, NO q param
    endpoint = `/api/v1/admin/medicine_descriptions?type=${type}`;
  } else if (!type) {
    // normal list with pagination
    endpoint = `/api/v1/admin/medicine_descriptions?page=${page}&per_page=${pageSize}`;
  } else {
    // search with pagination
    endpoint = `/api/v1/admin/medicine_descriptions?q=${q}&page=${page}&per_page=${pageSize}`;
  }
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getTestShortCuts = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  const endpoint = !type
    ? `/api/v1/admin/medical_test_shortcodes?page=${page}&per_page=${pageSize}`
    : `/api/v1/admin/medical_test_shortcodes?q=${type}&page=${page || 1}&per_page=${pageSize || 10}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getDiagnosisList = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  let endpoint;

  if (type === "all") {
    // NO pagination, NO q param
    endpoint = `/api/v1/admin/treatments/diagnoses`;
  } else if (!type) {
    // normal list with pagination
    endpoint = `/api/v1/admin/diagnosis?page=${page}&per_page=${pageSize}`;
  } else {
    // search with pagination
    endpoint = `/api/v1/admin/diagnosis?q=${encodeURIComponent(type)}&page=${page}&per_page=${pageSize}`;
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getSpecialInstructionsList = async (
  page = 1,
  pageSize = 10,
  q,
  type = null,
) => {
  let endpoint = `/api/v1/admin/special_instructions`;

  // If type is passed → append to endpoint
  if (type) {
    endpoint += `?type=${type}`;
  }

  // Build query params
  let queryParams = [];

  if (q) queryParams.push(`q=${q}`);
  queryParams.push(`page=${page}`);
  queryParams.push(`per_page=${pageSize}`);

  endpoint += `?${queryParams.join("&")}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineRemarksAdmin = async (
  page = 1,
  pageSize = 10,
  type = null,
) => {
  const endpoint = !type
    ? `/api/v1/admin/medicine_remarks?page=${page}&per_page=${pageSize}`
    : `/api/v1/admin/medicine_remarks?q=${encodeURIComponent(type)}&page=${page || 1}&per_page=${pageSize || 10}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getFollowUpsAdmin = async (
  page = 1,
  pageSize = 10,
  q,
  type = null,
) => {
  let endpoint;
  if (type === "all") {
    // NO pagination, NO q param
    endpoint = `/api/v1/admin/followup_lists?type=${type}`;
  } else if (!type) {
    // normal list with pagination
    endpoint = `/api/v1/admin/followup_lists?page=${page}&per_page=${pageSize}`;
  } else {
    // search with pagination
    endpoint = `/api/v1/admin/followup_lists?q=${q}&page=${page}&per_page=${pageSize}`;
  }
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicalTest = async (
  page = 1,
  pageSize = 10,
  type = null,
  q,
) => {
  const endpoint =
    type === "all"
      ? `/api/v1/admin/medical_tests?type=${type}`
      : `/api/v1/admin/medical_tests?page=${page}&per_page=${pageSize}${
          q ? `&q=${q}` : ""
        }`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getLabsList = async (page = 1, pageSize = 10, type = null, q) => {
  const endpoint =
    type === "all"
      ? `/api/v1/admin/labs?type=${type}`
      : `/api/v1/admin/labs?page=${page}&per_page=${pageSize}${
          q ? `&q=${q}` : ""
        }`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const handleExportMedicineEnquiry = async (
  id,
  type,
  startDate,
  endDate,
) => {
  try {
    const endpoint = `/api/v1/admin/reports/medicines_enquiry?id=${id}&type=${type}&start_date=${startDate}&end_date=${endDate}`;

    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Export failed!");
    }

    // API RETURNS JSON, NOT FILE
    const data = await response.json();

    const enquiries = data?.payload?.medicine_enquiries || [];

    if (!enquiries.length) {
      alert("No data found to export");
      return;
    }

    // ******************************
    // Convert JSON -> CSV
    // ******************************

    let csv =
      "Date,Patient UID,Invoice UID,Batch,Name,Date Time,Medicine,Received Qty,Qty,Grand Total,Discount,Stock Left\n";

    enquiries.forEach((item) => {
      item?.invoices?.invoice_items?.forEach((inv) => {
        csv +=
          [
            item.date || "",
            inv.patient_uid || "",
            inv.invoice_uid || "",
            inv.batch || "",
            inv.name || "",
            inv.date || "",
            inv.medicine_name || "",
            inv.received_quantity || "",
            inv.quantity || "",
            inv.grand_total || "",
            inv.discount || "",
            inv.stock_left || "",
          ].join(",") + "\n";
      });
    });

    // Create file blob
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    link.download = `Medicine-Enquiry-${startDate}-to-${endDate}.csv`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
};

export const getLabExternalReports = async (date, page, perPage) => {
  const endpoint = `/api/v1/medical_test_reports/external_report_patients?date=${date}&page=${page}&per_page=${perPage}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getExternalReportForAPatient = async (date, patientId) => {
  const endpoint = `/api/v1/medical_test_reports/list_outsource_reports?date=${date}&patient_id=${patientId}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    return data;
    // if (data.status.status === "SUCCESS") {
    //   return data;
    // } else {
    //   console.log("error fetching medicine salt list ");
    // }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const summaryOfPatientRecording = async (appointmentId) => {
  const endpoint = `/api/v1/voices/${appointmentId}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    return data;
    // if (data.status.status === "SUCCESS") {
    //   return data;
    // } else {
    //   console.log("error fetching medicine salt list ");
    // }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getQueryListing = async (page, perPage, status, q) => {
  try {
    let endpoint = `/api/v1/queries?type=prescription&page=${page}&per_page=${perPage}`;

    const params = new URLSearchParams();

    // if (page) params.append("page", page);
    // if (perPage) params.append("per_page", perPage);
    if (status) params.append("status", status);
    if (q) params.append("search", q);

    const url = `${BASE_URL}${endpoint}&${params.toString()}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();

    if (data?.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching query listing");
    }
  } catch (error) {
    console.log(error?.message || "something went wrong");
  }
};

export const getDas28History = async (patientId) => {
  try {
    let endpoint = `/api/v1/prescriptions/das28_history?patient_id=${patientId}`;
    const url = `${BASE_URL}${endpoint}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await response.json();
    if (data?.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching query listing");
    }
  } catch (error) {
    console.log(error?.message || "something went wrong");
  }
};

export const showFeatureOrgBase = async () => {
  const endpoint = `/api/v1/admin/features`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    // return data;
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine salt list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getLedgerEntries = async (id, startDate, endDate) => {
  const endpoint = `/api/v1/pharmacy/ledger_entries?supplier_id=${id}&from=${startDate}&to=${endDate}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const checkAvailableTest = async (names = []) => {
  // Build query string: names[]=platelet+count&names[]=basophils&...
  const queryString = names
    .filter(Boolean)
    .map((name) => `names[]=${encodeURIComponent(name)}`)
    .join("&");

  const endpoint = `/api/v1/medical_tests?${queryString}&per_page=100`;

  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medical test list");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getExternalReportForAPatientAll = async (patientId) => {
  const endpoint = `/api/v1/medical_test_reports/list_outsource_reports?patient_id=${patientId}&type=all`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    return data;
    // if (data.status.status === "SUCCESS") {
    //   return data;
    // } else {
    //   console.log("error fetching medicine salt list ");
    // }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMergedReports = async ({
  patientId,
  page = 1,
  perPage = 50,
  reportType,
  status,
  startDate,
  endDate,
  medicalTestIds,
} = {}) => {
  const params = new URLSearchParams({
    patient_id: patientId,
    page,
    per_page: perPage,
  });
  if (reportType) params.append("report_type", reportType);
  if (status) params.append("status", status);
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);

  let queryString = params.toString();
  if (medicalTestIds?.length) {
    const idsQuery = medicalTestIds
      .map((id) => `medical_test_ids[]=${encodeURIComponent(id)}`)
      .join("&");
    queryString += `&${idsQuery}`;
  }

  const endpoint = `/api/v1/medical_test_reports/medicaltest_reports_v2?${queryString}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getMedicineListBulkSearch = async (names = []) => {
  const queryString = names
    .filter(Boolean)
    .map((name) => `name[]=${encodeURIComponent(name)}`)
    .join("&");

  const endpoint = `/api/v1/pharmacy/medicines?${queryString}&per_page=${100}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching medicine list ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getDiagnosisRecommendations = async (
  diagnosis,
  type,
  doctor_id,
) => {
  const endpoint = `/api/v1/ai_summaries/prescription_recommendations?diagnosis=${diagnosis}&type=${type}&doctor_id=${doctor_id}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.success === true) {
      return data;
    } else {
      console.log("error fetching diagnosis recommendations");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const diagnosisSearch = async (q) => {
  const endpoint = `/api/v1/prescriptions/diagnoses_list?q=${q}`;
  try {
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getAiSummaryS3 = async (type, resourceId, resourceType) => {
  const endpoint = `/api/v1/ai_summaries/display?summary_type=${type}&resource_id=${resourceId}&resource_type=${resourceType}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getPatientAiSummary = async (
  patientId,
  resourceId,
  resourceType,
  summaryType,
  promptType,
) => {
  const params = new URLSearchParams({
    patient_id: patientId,
    resource_id: resourceId,
    resource_type: resourceType,
    summary_type: summaryType,
  });

  // optional
  if (promptType) {
    params.append("prompt_type", promptType);
  }

  const endpoint = `/api/v1/ai_summaries/patient_ai_summary?${params.toString()}`;

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();

    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("Error fetching patient AI summary");
      return null;
    }
  } catch (error) {
    console.log(error.message || "Something went wrong");
    return null;
  }
};

export const getJointAssessment = async (resourceId) => {
  const endpoint = `/api/v1/report_assessments/${resourceId}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const getJointAssessmentList = async (resourceId) => {
  const endpoint = `/api/v1/report_assessments?resource_id=${resourceId}&resource_type=Appointment`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const fetchExternalMeds = async (patientId, appointmentId) => {
  const endpoint = `/api/v1/external_medications/?patient_id=${patientId}&appointment_id=${appointmentId}`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

export const fetchVisitType = async () => {
  const endpoint = `/api/v1/appointments/visit_types`;
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status?.status === "SUCCESS") {
      return data;
    } else {
      console.log("error fetching diagnosis ");
    }
  } catch (error) {
    console.log(error.message || "something went wrong");
  }
};

// Fetch full medicine stock report (all medicines in the system)
export const getMedicineStockReport = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/pharmacy/medicines/stock_report`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );
    if (response.ok) {
      const data = await response.json();
      return data;
    }
    throw new Error(`stock_report -> HTTP ${response.status}`);
  } catch (e) {
    console.warn("[stockReport] failed:", e.message);
    return null;
  }
};

// Sales + refunds for a medicine (optionally narrowed to one batch).
// refund[]=true&refund[]=false returns both sides in a single call; the caller
// splits them on the `refund` flag of each invoice item.
export const getInvoiceItemsByBatch = async (
  itemableId,
  batchNo,
  itemableType = "Medicine",
) => {
  const params = new URLSearchParams();
  params.append("itemable_type", itemableType);
  if (itemableId != null && itemableId !== "")
    params.append("itemable_id", itemableId);
  if (batchNo) params.append("batch_no", batchNo);
  params.append("refund[]", "true");
  params.append("refund[]", "false");

  const response = await fetch(
    `${BASE_URL}/api/v1/pharmacy/invoice_items?${params.toString()}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    },
  );
  if (!response.ok) throw new Error(`invoice_items -> HTTP ${response.status}`);

  const data = await response.json();
  if (data?.status?.status !== "SUCCESS")
    throw new Error(data?.status?.message || "Could not load sales data");
  return data;
};
